"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTeamsTaskConfig = exports.getManualTaskConfig = exports.IN_PROGRESS_STATUS = exports.FAILED_PROGRESS_STATUS = exports.FAILED_DURING_CONVERSION = exports.COMPLETED_PROGRESS_STATUS = void 0;
var _BackgroundContext = require("@/context/BackgroundContext");
var _constants = require("@/util/constants");
var IN_PROGRESS_STATUS = exports.IN_PROGRESS_STATUS = "IN_PROGRESS";
var FAILED_PROGRESS_STATUS = exports.FAILED_PROGRESS_STATUS = "FAILED";
var FAILED_DURING_CONVERSION = exports.FAILED_DURING_CONVERSION = "FAILED DURING CONVERSION";
var COMPLETED_PROGRESS_STATUS = exports.COMPLETED_PROGRESS_STATUS = "COMPLETED";
var FAILED_CONVERSION_MESSAGE = "Failed PDF conversion for Preview";
var validateUploadedFileManualResponse = function validateUploadedFileManualResponse(task, uploaded_files) {
  var pollingResponse = task.pollingResponse,
    file = task.file;
  var name = file.name;
  if (uploaded_files.includes(name)) {
    var _spplitedName$at;
    var spplitedName = name.split(".");
    if (_constants.FILE_TYPE_NO_CONVERSION.includes((_spplitedName$at = spplitedName.at(-1)) !== null && _spplitedName$at !== void 0 ? _spplitedName$at : "")) {
      return {
        text: "File successfully uploaded",
        status: COMPLETED_PROGRESS_STATUS
      };
    }
    if (pollingResponse) {
      var _pollingResponse$data;
      // Handle the case when pollingResponse exists (add your logic here)
      var pollingResultFiles = (_pollingResponse$data = pollingResponse.data) === null || _pollingResponse$data === void 0 ? void 0 : _pollingResponse$data.result[0];
      var files = pollingResultFiles.files;
      var found = files.find(function (f) {
        return f.name === name;
      });
      if ((found === null || found === void 0 ? void 0 : found.status) === "COMPLETED") {
        return {
          text: "File successfully uploaded",
          status: COMPLETED_PROGRESS_STATUS
        };
      }
      if ((found === null || found === void 0 ? void 0 : found.status) === "FAILED") {
        return {
          status: FAILED_DURING_CONVERSION,
          text: FAILED_CONVERSION_MESSAGE
        };
      }
    }
    if (task.status === _BackgroundContext.FAILED_STATUS) {
      return {
        status: FAILED_DURING_CONVERSION,
        text: FAILED_CONVERSION_MESSAGE
      };
    }
    return {
      status: IN_PROGRESS_STATUS,
      text: "Conversion process in progress"
    };
  }
};
var getManualTaskConfig = exports.getManualTaskConfig = function getManualTaskConfig(task) {
  var _response$data;
  var response = task.response,
    file = task.file;
  var name = file.name;
  var respondedFiles = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.result[0];
  if (respondedFiles) {
    var skipped_files = respondedFiles.skipped_files,
      uploaded_files = respondedFiles.uploaded_files;
    // Look for the file on the skipped list
    if (skipped_files.includes(name)) {
      return {
        text: "Failed during uploading",
        status: FAILED_PROGRESS_STATUS
      };
    }
    return validateUploadedFileManualResponse(task, uploaded_files);
  }
  return {
    text: "Process failed",
    status: FAILED_PROGRESS_STATUS
  };
};
var getTeamsTaskConfigStatus = function getTeamsTaskConfigStatus(foundTask) {
  if (foundTask.status === "COMPLETED") {
    return {
      text: "File successfully uploaded",
      status: COMPLETED_PROGRESS_STATUS
    };
  }
  if (foundTask.status === "IN_PROGRESS") {
    return {
      text: "".concat(foundTask.task.toLowerCase(), " in progress"),
      status: IN_PROGRESS_STATUS
    };
  }
  if (foundTask.status === "FAILED") {
    return {
      text: foundTask.task === "CONVERT" ? FAILED_CONVERSION_MESSAGE : "Failed during ".concat(foundTask.task.toLowerCase(), " process"),
      status: foundTask.task === "CONVERT" ? FAILED_DURING_CONVERSION : FAILED_PROGRESS_STATUS
    };
  }
};
var getTeamsTaskConfig = exports.getTeamsTaskConfig = function getTeamsTaskConfig(task) {
  var pollingResponse = task.pollingResponse,
    status = task.status,
    file = task.file;
  var name = file.name;
  if (pollingResponse) {
    var _pollingResponse$data2;
    var resultArr = (_pollingResponse$data2 = pollingResponse.data) === null || _pollingResponse$data2 === void 0 ? void 0 : _pollingResponse$data2.result;
    var resultObj = Array.isArray(resultArr) && resultArr.length > 0 ? resultArr[0] : undefined;
    if (resultObj !== null && resultObj !== void 0 && resultObj.files) {
      var files = resultObj.files;
      var found = files.find(function (file) {
        return file.name === name;
      });
      if (found) {
        return getTeamsTaskConfigStatus(found);
      }
    }
  }
  if (status === _BackgroundContext.FAILED_STATUS) {
    return {
      text: "Process failed",
      status: FAILED_PROGRESS_STATUS
    };
  }
  return {
    text: "Upload in progress",
    status: IN_PROGRESS_STATUS
  };
};